import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import frLocale from 'date-fns/locale/fr';
import moment from 'moment-timezone';
import { Checkbox } from '@material-ui/core';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { get, isEmpty, orderBy, uniqueId } from 'lodash';
import DateFnsUtils from '@date-io/date-fns';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import useDeepCompareEffect from 'use-deep-compare-effect';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import {
  ASSIGN_EXPERT,
  EMPTY_ASSIGN_EXPERT,
  EMPTY_DOCUMENT,
  LISTINGS,
} from 'containers/data-structure';
import { FormContainer } from 'containers/CourtManagerLegalProceedings/AssignExpert/styled-components';
import { Config } from 'containers/AppContainer/typings';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { extractExpertCode } from 'containers/CourtManagerLegalProceedings/utils';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import { DATE_FORMAT, DOCUMENT_TYPES } from 'constants/global';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import {
  DOC_ID_INVITATION,
  EXPERTISE_MECHANIC_ID,
  EXPERTISE_MEDICAL_ID,
  invitationDoc,
} from 'containers/CourtManagerLegalProceedings/constants';
import { LABEL_WIDTH } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/constants';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import {
  filterVictim,
  resolveExpertiseType,
} from 'containers/CourtManagerLegalProceedings/utils';
import { StyledTitle } from 'containers/CourtManagerLegalProceedings/AssignExpert/styled-components';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import {
  compareDate,
  filtredNatureProcedure,
  containsAppeal,
} from 'containers/CourtManagerLegalProceedings/AssignExpert/utils';
import { OPENING_STATE } from 'services/constants';

export interface AssignExpertFormProps {
  intl: IntlShape;
  //UPLOAD PROPS
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  setDocumentId: Function;
  documentId: string;
  assignExpert: {};
  setAssignExpertFields: Function;
  listings: any;
  victims: any;
  invitationDoc: {};
  setInvitationDoc: Function;
  stakeholders: any;
  corporealLawyers: any;
  corporealExperts: any;
  requestGetExpertUsers: Function;
  selectedVictim?: any;
  document?: any;
  vehicles: any;
  isUpdate?: boolean;
  selectedVehicle?: any;
  civilProceeding?: any;
  claimRecap: any;
  claimHasCivilPartyJudiciaryProcess?: any;
}
const AssignExpertForm: React.FC<AssignExpertFormProps> = (
  props,
): JSX.Element => {
  const inputLabel = React.useRef<HTMLLabelElement>(null);
  const [invitationDoc, setInvitationDocs] = useState<invitationDoc>(
    props.document
      ? props.document
      : {
          ...EMPTY_DOCUMENT,
        },
  );
  const [assignedExperts, setAssignedExperts] = React.useState<string[]>([]);

  const handleChangeSelect = (event: any) => {
    const {
      target: { value },
    } = event;
    const formattedValue = value.filter((el: string) => el);
    setAssignedExperts(
      // On autofill we get a stringified value.
      formattedValue,
    );
    props.setAssignExpertFields({
      ...props.assignExpert,
      assignedExperts: formattedValue.map((element: any) => ({
        expertCode: element,
      })),
    });
  };
  const [victimState, setVictimState] = React.useState<any>(
    props.selectedVictim ? props.selectedVictim : [],
  );
  const [vehiclesState, setVehiclesState] = React.useState<any>(
    props.selectedVehicle ? props.selectedVehicle : [],
  );
  const [assignExpertForm, setAssignExpertForm] = React.useState({
    ...EMPTY_ASSIGN_EXPERT,
  });

  const handleChangeSelectVictim = (event: any) => {
    const {
      target: { value },
    } = event;
    if (Number(get(props.assignExpert, [ASSIGN_EXPERT.TYPE], '')) === 2) {
      if (props.isUpdate) {
        setVictimState(
          // On autofill we get a stringified value.
          [value],
        );
        props.setAssignExpertFields({
          ...props.assignExpert,
          victims: [{ id: value }],
        } as any);
        setAssignExpertForm({
          ...assignExpertForm,
          victims: [{ id: value }],
        } as any);
      } else {
        setVictimState(
          // On autofill we get a stringified value.
          value,
        );
        props.setAssignExpertFields({
          ...props.assignExpert,
          victims: value,
        } as any);
        setAssignExpertForm({
          ...assignExpertForm,
          victims: value,
        } as any);
      }
    } else {
      if (props.isUpdate) {
        setVictimState(
          // On autofill we get a stringified value.
          [value],
        );
        props.setAssignExpertFields({
          ...props.assignExpert,
          vehicles: [],
          victims: [{ id: value }],
        } as any);
        setAssignExpertForm({
          ...assignExpertForm,
          vehicles: [],
          victims: [{ id: value }],
        } as any);
      } else {
        setVictimState(
          // On autofill we get a stringified value.
          value,
        );
        props.setAssignExpertFields({
          ...props.assignExpert,
          vehicles: [],
          victims: value,
        } as any);
        setAssignExpertForm({
          ...assignExpertForm,
          vehicles: [],
          victims: value,
        } as any);
      }
    }
  };

  const handleChangeSelectVehicles = (event: any) => {
    const {
      target: { value },
    } = event;
    if (props.isUpdate) {
      setVehiclesState(
        // On autofill we get a stringified value.
        [value],
      );
      props.setAssignExpertFields({
        ...props.assignExpert,
        victims: [],
        vehicles: [{ id: value }],
      });
      setAssignExpertForm({
        ...assignExpertForm,
        victims: [],
        vehicles: [{ id: value }],
      } as any);
    } else {
      setVehiclesState(
        // On autofill we get a stringified value.
        value,
      );
      props.setAssignExpertFields({
        ...props.assignExpert,
        victims: [],
        vehicles: value,
      });
      setAssignExpertForm({
        ...assignExpertForm,
        victims: [],
        vehicles: value,
      } as any);
    }
  };

  const handleChange = (field: string) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    if (field === ASSIGN_EXPERT.TYPE) {
      props.requestGetExpertUsers(resolveExpertiseType(event.target.value));
      props.setAssignExpertFields({
        ...props.assignExpert,
        vehicles: [],
        victims: [],
        [field]: event.target.value,
      });
      setAssignExpertForm({
        ...assignExpertForm,
        vehicles: [],
        victims: [],
        [field]: event.target.value,
      } as any);

      const lawyerInfo = props.corporealLawyers.filter(
        (element: { attributes: { sagis_code: any } }) =>
          get(element, 'attributes.sagis_code[0]', '') ===
          get(props.assignExpert, [ASSIGN_EXPERT.LAWYER]),
      );

      const experts =
        lawyerInfo &&
        !isEmpty(get(lawyerInfo, '[0].attributes.experts_code[0]', [])) &&
        get(lawyerInfo, '[0].attributes.experts_code[0]', [])
          .split(',')
          .filter(
            (element: any) =>
              element.toString() ===
              get(
                props.corporealExperts,
                '[0].attributes.sagis_code[0]',
                '',
              ).toString(),
          );
      if (!isEmpty(experts)) {
        setAssignedExperts([get(experts, '[0]', null)]);
        props.setAssignExpertFields({
          ...props.assignExpert,
          [field]: event.target.value,
          assignedExperts: [get(experts, '[0]', null)].map((element: any) => ({
            expertCode: element,
          })),
        });
      }
    } else {
      props.setAssignExpertFields({
        ...props.assignExpert,
        [field]: event.target.value,
      });
      setAssignExpertForm({
        ...assignExpertForm,
        [field]: event.target.value,
      });
    }
  };

  const handleLossHourChange = (event: any) => {
    const { value } = event.target || '';

    const time = value.replace(':', '');
    const [hours, minutes] = [time.slice(0, 2), time.slice(2, 4)];
    const [hoursForTest, minutesForTest] = [hours, minutes].map((t: any) =>
      t && t.length < 2 ? t * 10 : t,
    );
    if (hoursForTest < 24 && (!minutes || minutesForTest < 60)) {
      props.setAssignExpertFields({
        ...props.assignExpert,
        hour: [hours, minutes].filter(t => !!t).join(':'),
      });
      setAssignExpertForm({
        ...assignExpertForm,
        hour: [hours, minutes].filter(t => !!t).join(':'),
      });
    }
  };

  const handleDateChange = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const missionDate = moment(theDate as Date).format(DATE_FORMAT);
    props.setAssignExpertFields({
      ...props.assignExpert,
      missionDate: missionDate,
    });
    setAssignExpertForm({
      ...assignExpertForm,
      missionDate: missionDate,
    });
  };

  const setDocumentInvitation = (document: CorporealDocument) => {
    if (get(document, 'id')) {
      setAssignExpertForm({
        ...assignExpertForm,
      });
      props.setAssignExpertFields({
        ...props.assignExpert,
      });
      setInvitationDocs({
        name: document.name,
        type: document.type,
        url: document.url,
        id: get(document, 'id'),
        missionId: get(document, 'missionId'),
      } as any);
      props.setInvitationDoc({
        name: document.name,
        type: document.type,
        url: document.url,
        id: get(document, 'id'),
        missionId: get(document, 'missionId'),
      } as any);
    } else {
      setAssignExpertForm({
        ...assignExpertForm,
      });
      props.setAssignExpertFields({
        ...props.assignExpert,
      });
      setInvitationDocs({
        name: document.name,
        type: document.type,
        url: document.url,
      });
      props.setInvitationDoc({
        name: document.name,
        type: document.type,
        url: document.url,
      });
    }
  };

  const handleReceiptDateChange = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const receiptDate = moment(theDate as Date).format(DATE_FORMAT);
    props.setAssignExpertFields({
      ...props.assignExpert,
      receiptDate: receiptDate,
    });
    setAssignExpertForm({
      ...assignExpertForm,
      receiptDate: receiptDate,
    });
  };

  const expert_nature = [
    {
      id: 1,
      title: translate(messages.medicalExpertise, props),
      isVisible: featureService.hasFeature(FEATURES.EXPERT_INTEGRATION),
    },
    {
      id: 2,
      title: translate(messages.accountingExpertise, props),
      isVisible: featureService.hasFeature(
        FEATURES.EXPERT_INTEGRATION_ACCOUNTING,
      ),
    },
    {
      id: 3,
      title: translate(messages.mechanicalExpertise, props),
      isVisible:
        featureService.hasFeature(FEATURES.EXPERT_INTEGRATION_MECHANIC) &&
        !isEmpty(props.vehicles),
    },
  ];

  const allMedicalExperts =
    props.corporealExperts &&
    props.corporealExperts.filter(
      (element: { attributes: { sagis_code: any } }) =>
        !isEmpty(get(element?.attributes, 'sagis_code', '')),
    );

  useDeepCompareEffect(() => {
    if (!get(props.assignExpert, 'assignedExpert')) {
      const lawyerInfo = props.corporealLawyers.filter(
        (element: { attributes: { sagis_code: any } }) =>
          get(element, 'attributes.sagis_code[0]', '') ===
          get(props.assignExpert, [ASSIGN_EXPERT.LAWYER]),
      );

      const experts =
        !isEmpty(lawyerInfo) &&
        !isEmpty(get(lawyerInfo, '[0].attributes.experts_code[0]', [])) &&
        get(lawyerInfo, '[0].attributes.experts_code[0]', [])
          .split(',')
          .filter((element: any) =>
            extractExpertCode(props.corporealExperts).includes(
              element?.toString(),
            ),
          );
      setAssignedExperts([get(experts, '[0]')]);
      props.setAssignExpertFields({
        ...props.assignExpert,
        assignedExperts: [get(experts, '[0]')].map((element: any) => ({
          expertCode: element,
        })),
      });
    } else if (!isEmpty(get(props.assignExpert, 'assignedExperts'))) {
      setAssignedExperts(
        get(props.assignExpert, 'assignedExperts').map(
          (element: any) => element.expertCode,
        ),
      );
      props.setAssignExpertFields({
        ...props.assignExpert,
        assignedExperts: get(props.assignExpert, 'assignedExperts').map(
          (element: any) => ({
            expertCode: element.expertCode,
          }),
        ),
      });
    }
  }, [props.corporealExperts]);

  const deleteDoc = () => {
    setAssignExpertForm({
      ...assignExpertForm,
    });
    props.setAssignExpertFields({
      ...props.assignExpert,
    });
    setInvitationDocs({ ...invitationDoc, url: '' });
    props.setInvitationDoc({ ...invitationDoc, url: '' });
  };
  const lawyerInfo = props.corporealLawyers.filter(
    (element: { attributes: { sagis_code: any } }) =>
      get(element, 'attributes.sagis_code[0]', '') ===
      get(props.assignExpert, [ASSIGN_EXPERT.LAWYER]),
  );
  const isUsageOpening =
    featureService.hasFeature(FEATURES.OPENING_BY_USAGE) &&
    get(props.claimRecap, 'claim.openingState', null) ===
      OPENING_STATE.NOT_COMPLETED;

  return (
    <FormContainer>
      <div className="subContainer fee-note-form">
        <FormControl>
          <InputLabel>{translate(messages.expertNature, props)}</InputLabel>
          <Select
            className="input"
            onChange={handleChange(ASSIGN_EXPERT.TYPE)}
            name={ASSIGN_EXPERT.TYPE}
            value={
              get(props.assignExpert, [ASSIGN_EXPERT.TYPE])
                ? get(props.assignExpert, [ASSIGN_EXPERT.TYPE])
                : null
            }
            disabled={props.isUpdate}
          >
            {expert_nature
              .filter(
                (element: { id: number; title: string; isVisible: boolean }) =>
                  element.isVisible,
              )
              .map(
                (element: {
                  id: number;
                  title: string;
                  isVisible: boolean;
                }) => (
                  <MenuItem value={element.id}>{element.title}</MenuItem>
                ),
              )}
          </Select>
        </FormControl>
        {(props.isUpdate &&
          !isEmpty(get(props.assignExpert, [ASSIGN_EXPERT.VEHICLES], ''))) ||
        (!props.isUpdate &&
          get(props.assignExpert, [ASSIGN_EXPERT.TYPE], '') &&
          Number(get(props.assignExpert, [ASSIGN_EXPERT.TYPE], '')) !=
            EXPERTISE_MEDICAL_ID) ? (
          <FormControl className="input">
            <InputLabel ref={inputLabel} id="idd-label-id">
              {translate(messages.vehiclesTitle, props)}
            </InputLabel>
            <Select
              labelId="idd-label-id"
              name={ASSIGN_EXPERT.VEHICLES}
              value={vehiclesState}
              renderValue={(vehicles: any) => {
                return (vehicles as any)
                  .map(
                    (element: any) =>
                      (props.vehicles as any).find(
                        (el: any) => el.id === element,
                      )?.registrationNumber as any,
                  )
                  .join(', ') as any;
              }}
              onChange={handleChangeSelectVehicles}
              labelWidth={60}
              multiple={!props.isUpdate}
            >
              {!isEmpty(props.vehicles) &&
                props.vehicles.map(
                  (val: { id: number; registrationNumber: string }) => (
                    <MenuItem key={uniqueId('val.id')} value={val.id}>
                      <Checkbox
                        checked={
                          String(vehiclesState).indexOf(val?.id as any) > -1
                        }
                      />
                      {val.registrationNumber}
                    </MenuItem>
                  ),
                )}
            </Select>
          </FormControl>
        ) : (
          <></>
        )}
        {(props.isUpdate &&
          !isEmpty(get(props.assignExpert, [ASSIGN_EXPERT.VICTIMS], ''))) ||
        (!props.isUpdate &&
          get(props.assignExpert, [ASSIGN_EXPERT.TYPE], '') &&
          Number(get(props.assignExpert, [ASSIGN_EXPERT.TYPE], '')) !=
            EXPERTISE_MECHANIC_ID) ? (
          <FormControl className="input">
            <InputLabel ref={inputLabel} id="idd-label-id">
              {translate(messages.victimsTitle, props)}
            </InputLabel>
            <Select
              labelId="idd-label-id"
              name={ASSIGN_EXPERT.VICTIMS}
              value={victimState}
              renderValue={(vic: any) =>
                ((vic as any).map(
                  (element: any) =>
                    ((props.victims as any).find((el: any) => el.id === element)
                      ?.firstName +
                      ' ' +
                      (props.victims as any).find(
                        (el: any) => el.id === element,
                      )?.lastName) as any,
                ) as any).join(', ') as any
              }
              onChange={handleChangeSelectVictim}
              labelWidth={60}
              multiple={!props.isUpdate}
            >
              {!isEmpty(props.victims) &&
                (isUsageOpening
                  ? props.victims
                  : filterVictim(props.victims)
                ).map(
                  (val: {
                    id: number;
                    firstName: string;
                    lastName: string;
                  }) => (
                    <MenuItem key={uniqueId('val.id')} value={val.id}>
                      <Checkbox
                        checked={
                          String(victimState).indexOf(val?.id as any) > -1
                        }
                      />
                      {val.firstName + ' ' + val.lastName}
                    </MenuItem>
                  ),
                )}
            </Select>
          </FormControl>
        ) : (
          <></>
        )}
        <FormControl className="input">
          <InputLabel ref={inputLabel} id="idd-label-id">
            {translate(messages.AvocatConseil, props)}
          </InputLabel>
          <Select
            labelId="idd-label-id"
            name={ASSIGN_EXPERT.LAWYER}
            value={get(props.assignExpert, [ASSIGN_EXPERT.LAWYER]) || ''}
            onChange={handleChange(ASSIGN_EXPERT.LAWYER)}
            labelWidth={60}
          >
            {!isEmpty(props.stakeholders) &&
              props.stakeholders.map(
                (val: {
                  ItemKey: string | number | readonly string[] | undefined;
                  ItemDescription: React.ReactNode;
                }) => (
                  <MenuItem key={uniqueId('stackholder_')} value={val.ItemKey}>
                    {val.ItemDescription}
                  </MenuItem>
                ),
              )}
          </Select>
        </FormControl>
        <FormControl className="input">
          <InputLabel ref={inputLabel} id="idd-label-id">
            {translate(messages.expertConseilField, props)}
          </InputLabel>
          <Select
            labelId="idd-label-id"
            name={ASSIGN_EXPERT.ASSIGNED_EXPERT}
            value={assignedExperts}
            renderValue={(assignedExperts: any) =>
              ((assignedExperts as any).map((element: any) =>
                getValueByCode(
                  element as string,
                  get(props.listings, 'intervenants'),
                ),
              ) as any).join(', ') as any
            }
            onChange={handleChangeSelect}
            labelWidth={60}
            multiple
          >
            <span style={{ fontSize: 15, padding: 5 }}>
              {translate(messages.associatedExperts, props)}
            </span>
            {!isEmpty(allMedicalExperts) &&
              allMedicalExperts
                .filter(
                  (el: any) =>
                    !isEmpty(
                      get(lawyerInfo, '[0].attributes.experts_code[0]', []),
                    ) &&
                    get(lawyerInfo, '[0].attributes.experts_code[0]', [])
                      .split(',')
                      .includes(get(el.attributes.sagis_code, '[0]', '')),
                )
                .map(
                  (val: {
                    attributes: { sagis_code: [] };
                    firstName: string;
                    lastName: string;
                  }) => (
                    <MenuItem
                      key={uniqueId('stackholder_')}
                      value={
                        get(val.attributes.sagis_code, '[0]')
                          ? get(val.attributes.sagis_code, '[0]')
                          : null
                      }
                    >
                      <Checkbox
                        checked={
                          assignedExperts.indexOf(
                            get(val.attributes.sagis_code, '[0]'),
                          ) > -1
                        }
                      />
                      {val.firstName + ' ' + val.lastName}
                    </MenuItem>
                  ),
                )}
            <br />
            <span style={{ fontSize: 15, padding: 5 }}>
              {translate(messages.otherExperts, props)}
            </span>
            {!isEmpty(allMedicalExperts) &&
              allMedicalExperts
                .filter(
                  (el: any) =>
                    (!isEmpty(
                      get(lawyerInfo, '[0].attributes.experts_code[0]', []),
                    ) &&
                      !get(lawyerInfo, '[0].attributes.experts_code[0]', [])
                        .split(',')
                        .includes(get(el.attributes.sagis_code, '[0]'))) ||
                    isEmpty(
                      get(lawyerInfo, '[0].attributes.experts_code[0]', []),
                    ),
                )
                .map(
                  (val: {
                    attributes: { sagis_code: [] };
                    firstName: string;
                    lastName: string;
                  }) => (
                    <MenuItem
                      key={uniqueId('stackholder_')}
                      value={
                        get(val.attributes.sagis_code, '[0]')
                          ? get(val.attributes.sagis_code, '[0]')
                          : null
                      }
                    >
                      <Checkbox
                        checked={
                          assignedExperts.indexOf(
                            get(val.attributes.sagis_code, '[0]'),
                          ) > -1
                        }
                      />
                      {val.firstName + ' ' + val.lastName}
                    </MenuItem>
                  ),
                )}
          </Select>
        </FormControl>
        <TextField
          label={translate(messages.ExpertJudiciareField, props)}
          className="input"
          name={ASSIGN_EXPERT.LEGAL_EXPERT}
          onChange={handleChange(ASSIGN_EXPERT.LEGAL_EXPERT)}
          value={get(props.assignExpert, [ASSIGN_EXPERT.LEGAL_EXPERT]) || ''}
        />
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
          <KeyboardDatePicker
            autoOk
            variant="inline"
            invalidDateMessage=""
            format="dd/MM/yyyy"
            id="lossDate"
            onChange={handleDateChange}
            name={ASSIGN_EXPERT.MISSION_DATE}
            value={dateStringToLocalDate(
              get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], ''),
            )}
            label={translate({ ...messages.ExpertDate }, props)}
            className="input"
            error={
              new Date(
                get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], ''),
              ) < new Date(moment().format('YYYY-MM-DD')) ||
              get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], '') ===
                '' ||
              get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], '') ===
                null ||
              get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], '') ===
                'Invalid date'
            }
            helperText={
              new Date(
                get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], ''),
              ) < new Date(moment().format('YYYY-MM-DD')) ||
              get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], '') ===
                '' ||
              get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], '') === null
                ? translate(messages.missionExpertiseDateError, props)
                : get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], '') ===
                  'Invalid date'
                ? translate(messages.invalidDate, props)
                : ''
            }
          />
        </MuiPickersUtilsProvider>
        <TextField
          id="date-picker-claim-loss-hour"
          onChange={handleLossHourChange}
          name={ASSIGN_EXPERT.HOUR}
          value={get(props.assignExpert, [ASSIGN_EXPERT.HOUR], null)}
          label={translate({ ...messages.ExpertHour }, props)}
          className="input"
          placeholder="HH:MM"
        />
        <FormControl className="input">
          <InputLabel id="idd-label-id">
            {translate(messages.town, props)}
          </InputLabel>
          <Select
            labelId="idd-label-id"
            onChange={handleChange(ASSIGN_EXPERT.CITY)}
            name={ASSIGN_EXPERT.CITY}
            value={get(props.assignExpert, [ASSIGN_EXPERT.CITY]) || ''}
            labelWidth={LABEL_WIDTH}
          >
            {!isEmpty(props.listings.jurisdiction) &&
              orderBy(
                get(props.listings, 'jurisdiction', []),
                [el => el?.title?.toLowerCase()],
                ['asc'],
              ).map((el: Config) => (
                <MenuItem key={el.id} value={el.id}>
                  {el.title}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <TextField
          label={translate(messages.ExpertAdress, props)}
          className="input"
          name={ASSIGN_EXPERT.ADDRESS}
          onChange={handleChange(ASSIGN_EXPERT.ADDRESS)}
          value={get(props.assignExpert, [ASSIGN_EXPERT.ADDRESS]) || ''}
        />
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
          <KeyboardDatePicker
            autoOk
            variant="inline"
            invalidDateMessage=""
            format="dd/MM/yyyy"
            id="lossDate"
            onChange={handleReceiptDateChange}
            name={ASSIGN_EXPERT.RECEIPT_DATE}
            value={dateStringToLocalDate(
              get(props.assignExpert, [ASSIGN_EXPERT.RECEIPT_DATE], ''),
            )}
            label={translate({ ...messages.receiptDateField }, props)}
            className="input"
            error={
              new Date(
                get(props.assignExpert, [ASSIGN_EXPERT.RECEIPT_DATE], ''),
              ) > new Date(moment().format('YYYY-MM-DD')) ||
              get(props.assignExpert, [ASSIGN_EXPERT.RECEIPT_DATE], '') ===
                '' ||
              get(props.assignExpert, [ASSIGN_EXPERT.RECEIPT_DATE], '') ===
                null ||
              get(props.assignExpert, [ASSIGN_EXPERT.RECEIPT_DATE], '') ===
                'Invalid date'
            }
            helperText={
              new Date(
                get(props.assignExpert, [ASSIGN_EXPERT.RECEIPT_DATE], ''),
              ) > new Date(moment().format('YYYY-MM-DD')) ||
              get(props.assignExpert, [ASSIGN_EXPERT.RECEIPT_DATE], '') ===
                '' ||
              get(props.assignExpert, [ASSIGN_EXPERT.RECEIPT_DATE], '') === null
                ? translate(messages.missionRecieptDateError, props)
                : get(props.assignExpert, [ASSIGN_EXPERT.RECEIPT_DATE], '') ===
                  'Invalid date'
                ? translate(messages.invalidDate, props)
                : ''
            }
          />
        </MuiPickersUtilsProvider>
        {compareDate(
          get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], ''),
          get(props.assignExpert, [ASSIGN_EXPERT.RECEIPT_DATE], ''),
        ) <= 5 && (
          <StyledTitle>
            {translate({ ...messages.missionWarningReceiptDateTitle }, props)}
          </StyledTitle>
        )}
        <FormControl>
          <InputLabel>{translate(messages.NatureProceeding, props)}</InputLabel>
          <Select
            className="input"
            name={ASSIGN_EXPERT.PROCEDURE_NATURE_ID}
            value={String(
              get(props.assignExpert, ASSIGN_EXPERT.PROCEDURE_NATURE_ID, ''),
            )}
            onChange={handleChange(ASSIGN_EXPERT.PROCEDURE_NATURE_ID)}
          >
            {filtredNatureProcedure(
              props.civilProceeding,
              props.claimHasCivilPartyJudiciaryProcess,
              get(props.listings, LISTINGS.PROCEDURE_NATURE, []),
            ).map((el: Config) => (
              <MenuItem key={el.id} value={String(el.id)}>
                {el.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {get(props.assignExpert, ASSIGN_EXPERT.PROCEDURE_NATURE_ID, '') &&
        Number(
          get(props.assignExpert, ASSIGN_EXPERT.PROCEDURE_NATURE_ID, ''),
        ) != 3 ? (
          <FormControl>
            <InputLabel>{translate(messages.procedure, props)}</InputLabel>
            <Select
              className="input"
              name={ASSIGN_EXPERT.JUDICIARY_PROCESS_ID}
              value={String(
                get(props.assignExpert, ASSIGN_EXPERT.JUDICIARY_PROCESS_ID, ''),
              )}
              onChange={handleChange(ASSIGN_EXPERT.JUDICIARY_PROCESS_ID)}
            >
              {props.civilProceeding
                .filter(
                  (el: any) =>
                    el.procedureNatureId ===
                    Number(
                      get(
                        props.assignExpert,
                        ASSIGN_EXPERT.PROCEDURE_NATURE_ID,
                        '',
                      ),
                    ),
                )
                .map((el: { id: number; courtNumber: string }) => (
                  <MenuItem key={el.id} value={String(el.id)}>
                    {el.courtNumber}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        ) : (
          <></>
        )}
        <FormControl>
          <InputLabel>{translate(messages.step, props)}</InputLabel>
          <Select
            className="input"
            onChange={handleChange(ASSIGN_EXPERT.STEP)}
            name={ASSIGN_EXPERT.STEP}
            value={get(props.assignExpert, [ASSIGN_EXPERT.STEP])}
          >
            {(containsAppeal(
              props.civilProceeding,
              get(props.assignExpert, ASSIGN_EXPERT.PROCEDURE_NATURE_ID),
              get(props.assignExpert, ASSIGN_EXPERT.JUDICIARY_PROCESS_ID, ''),
              props.claimHasCivilPartyJudiciaryProcess,
            )
              ? get(props.listings, 'jurisdictionDegrees', [])
              : get(props.listings, 'jurisdictionDegrees', []).filter(
                  (item: any) => item.id != 2,
                )
            ).map((element: { id: number; title: string }) => (
              <MenuItem value={element.id}>{element.title}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <UploadDocumentBloc
          index={0}
          title={translate(messages.uploadConvocationTitle, props)}
          document={invitationDoc}
          resetUploadedDocument={props.resetUploadedDocument}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          docType={DOCUMENT_TYPES.INVITATION}
          setDocumentId={props.setDocumentId}
          setDocument={setDocumentInvitation}
          shouldDisplay={true}
          docId={DOC_ID_INVITATION}
          deleteDoc={deleteDoc}
        />
      </div>
    </FormContainer>
  );
};

export default injectIntl(AssignExpertForm);
